module.exports = __webpack_public_path__ + "static/media/express-original.c3af8b67.svg";